import { PagedResult } from "types/apis"
import { WorkawareApi } from "../../apis/WorkawareApi"
import { EventModel } from "../models/EventModel"

export class eventsService {
    private _api: WorkawareApi
    constructor(api: WorkawareApi) {
        this._api = api;
    }
    get = (page: number, rowsPerPage: number, userId?: number) => {
        return new Promise<PagedResult<EventModel>>((resolve, reject) => {
            this._api.events.get(page, rowsPerPage)
                .then(result => {
                    let values: EventModel[] = result.Values
                    if (userId) {
                        values = values.filter((item: EventModel) => item.UserId === userId)
                    }
                    resolve({
                        Count: userId ? values.length : result["Count"] as number,
                        Values: values
                    })
                })
                .catch(error => reject(error))
        })
    }

    deleteEvent = (id?: number) => new Promise<void>((resolve, reject) => {
        if (id === undefined) {
            return reject('id is undefined');
        }
        this._api.events.delete(id)
            .then(() => resolve())
            .catch(error => reject(error));
    });
}